import { Buffer } from 'buffer';

export class RouterHelper {
  static encodeQueryParameter(uncodedParam: string) {
    return Buffer.from(uncodedParam).toString('base64');
  }

  static decodeQueryParameter(encodedParam: string) {
    try {
      if (!encodedParam) {
        return undefined;
      }
      return Buffer.from(encodedParam, 'base64').toString('utf8');
    } catch (e) {
      return undefined;
    }
  }

  static getQueryParameter(param: string | string[]) {
    return Array.isArray(param) ? param[0] : param;
  }

  static dashboardPath = '/dashboard';
  static newDashboardPath = '/new-dashboard';
  static roomsPath = '/rooms';
  static securityPath = '/settings/security';
}
